import { Service, ServicesHook, UserServicesRequest } from "@models";
import { useStore } from "@stores";
import { SelectProps } from "antd";
import { useEffect, useMemo } from "react";

export const useUserServices = ({
  userId,
  tenantId,
}: UserServicesRequest): ServicesHook => {
  const { userStore } = useStore();
  const { servicesLoading, services } = userStore;

  useEffect(() => {
    if (userId && tenantId) userStore.getServices({ userId, tenantId });
  }, [userStore, userId, tenantId]);

  const dataSource = Array.from(services.values()) as Service[];

  const serviceOptions: SelectProps["options"] = useMemo(
    () =>
      dataSource.map((x) => {
        const price = x.isPricePublic && x.price ? ` - ${x.price} din` : "";
        const duration =
          x.isDurationPublic && x.duration ? ` · ${x.duration} min` : "";
        const label = `${x.name}${price}${duration}`;
        return {
          value: x.id,
          label,
        };
      }),
    [dataSource],
  );

  return {
    dataSource,
    loading: servicesLoading,
    serviceOptions,
  };
};
